import React from 'react';

export const ActivityIcon = () => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.6875 7H5.0625L7.3125 0.8125L10.6875 13.1875L12.9375 7H16.3125"
        stroke="#5F5F8C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
